export default __webpack_public_path__ + "static/background-pattern-abcce1b948cb7308bb1bb79536a7e8b6.svg";